import { render, staticRenderFns } from "./CouponListFilters.vue?vue&type=template&id=ed436928&"
import script from "./CouponListFilters.vue?vue&type=script&lang=js&"
export * from "./CouponListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CouponListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports